import React from 'react';
import { Outlet } from 'react-router-dom';
import StudentLayoutClient from '../pages/student-layout-client';
import { StudentSidebarProvider } from '../context/StudentSidebarContext';

export default function StudentLayout() {
  return (
    <StudentSidebarProvider>
      <StudentLayoutClient initialOrgSyncState={null}>
        <Outlet />
      </StudentLayoutClient>
    </StudentSidebarProvider>
  );
}
